<template>
  <li
    :class="{ 'is-actived':actived, ' ':true,'is-disabled': disabled, 'xy-divider': divided, custom: custom }">
    <a
      :href="href?href:'javascript:void(0)'"
      v-if="!divided && !custom"
      @click="handleClick"
    >
      <div class="xy-svg-icon">
        <svg-icon :name="icon" size="50"></svg-icon>
      </div>
      <span> <slot v-if="!custom"></slot> </span
    ></a>
    <slot v-if="custom"></slot>
  </li>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    command: {},
    disabled: Boolean,
    divided: Boolean,
    actived :Boolean,
    custom: Boolean,
    icon: String,
    href:String,
  },
  methods: {
    handleClick(evt) {
      if(evt)
      this.$emit("click", evt);
    },
  },
};
</script>
